import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SubscriptionCancelPreviewData {
  messages: string[];
}

export type SubscriptionCancelPreviewResult = 'cancel_now' | 'schedule' | null;

@Component({
  selector: 'app-subscription-cancel-preview',
  template: `
    <div class="dialog__header txt--center dialog__header--warn">
      <h2 mat-dialog-title class="m--0 txt--xl"><strong>Cancel Subscription</strong></h2>
    </div>

    <div class="dialog__content dialog__content--height" mat-dialog-content>
      <div class="dialog-row">
        <p class="txt--lg txt--center m--0" *ngIf="data.messages?.length">
          <strong>These Stripe subscriptions will be paused / pending invoices will be voided:</strong>
        </p>
        <p class="txt--lg txt--center m--0" *ngIf="!data.messages?.length">
          <strong>There are no pending invoices or active Stripe subscriptions to void/pause.</strong>
        </p>
        <ul *ngIf="data.messages?.length">
          <li *ngFor="let m of data.messages">{{ m }}</li>
        </ul>
      </div>
    </div>

    <div mat-dialog-actions class="dialog__footer">
      <div class="alternate-theme d-inline-block mr--10">
        <button tabIndex="-1" mat-button color="primary" [mat-dialog-close]="null" class="btn btn-cancel">Dismiss</button>
      </div>
      <button tabIndex="-1" mat-flat-button color="accent" [mat-dialog-close]="'schedule'" class="btn btn--action">Schedule Cancel</button>
      <button tabIndex="-1" mat-flat-button color="warn" [mat-dialog-close]="'cancel_now'" class="btn btn--action">Cancel Now</button>
    </div>
  `
})
export class SubscriptionCancelPreviewComponent {
  // Type-only, read by ModalService.openModal to infer its result type. Never assigned.
  declare RESULT_TYPE: SubscriptionCancelPreviewResult;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: SubscriptionCancelPreviewData
  ) {}
}
